import type { LoadingButtonProps as MuiLoadingButtonProps } from '@mui/lab/LoadingButton';

import { FirebaseService } from '@mfw/firebase/services';
import MuiLoadingButton from '@mui/lab/LoadingButton';
import classNames from 'classnames';
import omit from 'lodash/omit';
import React from 'react';

import { type IconProps, getButtonIcon } from './getButtonIcon';
import './Button.scss';

export interface ButtonProps extends Omit<
  MuiLoadingButtonProps,
  'endIcon' | 'startIcon'
> {
  analyticsEventName?: string;
  startIcon?: IconProps;
  destructive?: boolean;
  endIcon?: IconProps;
}
export const Button = React.forwardRef(
  (props: ButtonProps, ref: React.ForwardedRef<HTMLButtonElement>) => {
    const otherProps = omit(props, 'destructive', 'helperText');
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      event?.stopPropagation();
      if (props.analyticsEventName)
        FirebaseService.getInstance().logEvent(props.analyticsEventName);
      if (props.onClick) {
        props.onClick(event);
      }
    };
    return (
      <MuiLoadingButton
        {...otherProps}
        className={classNames(
          'Mfw-Button',
          {
            'Mfw-Button--destructive': props.destructive,
          },
          props.className,
        )}
        aria-disabled={otherProps.disabled ? 'true' : 'false'}
        startIcon={getButtonIcon(props.startIcon)}
        endIcon={getButtonIcon(props.endIcon)}
        onClick={handleClick}
        ref={ref}
      />
    );
  },
);

Button.displayName = 'Button';

export default Button;
